var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-dropzones"},[_vm._l((_vm.zones),function(zone,i){return _c('rn-dropzone',{key:("zone-" + i),attrs:{"data":zone,"interactive":_vm.interactive},on:{"remove":_vm.remove}})}),_vm._t("dropzone-action")],2)}
var staticRenderFns = []

export { render, staticRenderFns }